@if (visible()) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4"
    style="background-color: rgba(26, 33, 43, 0.6);"
    (click)="onBackdropDismiss()"
    (keydown.escape)="onBackdropDismiss()"
    tabindex="-1"
  >
    <div
      class="relative w-full max-w-md bg-white rounded-3xl shadow-modal p-5 xs:p-8 text-center"
      (click)="$event.stopPropagation()"
      (keydown.escape)="$event.stopPropagation()"
      tabindex="-1"
    >
      @if (showCloseIcon()) {
        <button
          type="button"
          (click)="cancel.emit()"
          aria-label="Cerrar"
          class="absolute top-2 right-2 flex items-center justify-center w-11 h-11 rounded-full text-soft-gray hover:text-text-primary transition-colors"
        >
          <i class="fi fi-ss-cross text-base leading-none"></i>
        </button>
      }

      @if (iconStyle(); as icon) {
        <div
          class="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full"
          [style.background-color]="icon.bg"
        >
          <i class="fi {{ icon.icon }} text-2xl leading-none" [style.color]="icon.color"></i>
        </div>
      }

      @if (title()) {
        <h2 class="text-xl font-bold text-text-primary mb-2">{{ title() }}</h2>
      }
      @if (message()) {
        <p class="text-base text-text-secondary">{{ message() }}</p>
      }

      <ng-content />

      <div class="mt-6 flex flex-col xs:flex-row gap-3">
        @if (showCancel()) {
          <button
            type="button"
            (click)="cancel.emit()"
            class="flex-1 min-h-[44px] rounded-btn font-semibold text-base text-text-primary border border-soft-gray-outline transition-all"
          >
            {{ cancelText() }}
          </button>
        }
        <button
          type="button"
          [disabled]="confirmDisabled()"
          (click)="confirm.emit()"
          class="flex-1 min-h-[44px] rounded-btn font-semibold text-base text-white transition-all disabled:opacity-40 disabled:cursor-not-allowed"
          [style.background-color]="'var(--color-primary)'"
        >
          {{ confirmText() }}
        </button>
      </div>
    </div>
  </div>
}
